export default function () {
    $('img.js-lazyload').each(function(){
       $(this).attr('src', $(this).attr('data-src'));
    });
};

